/* global google */

const $ = jQuery;

export default class GoogleMap {
    constructor(gmap) {
        this.$gmap = $(gmap);
        this.markers = [];

        if (gmap.dataset.gmap === 'initialized') {
            return;
        }
        let center = new google.maps.LatLng(gmap.dataset.lat, gmap.dataset.lng);

        let map = new google.maps.Map(gmap, {
            fullscreenControl: false,
            mapTypeControl: false,
            rotateControl: false,
            streetViewControl: false,
            zoom: parseInt(gmap.dataset.zoom || '16', 10),
            center
        });
        let bounds = new google.maps.LatLngBounds();

        let locations = JSON.parse($(gmap).prev('.partnersmap__data').html());
        let infoWindow = new google.maps.InfoWindow();

        locations.forEach(location => {
            if (!location.geo_coordinates.lat || !location.geo_coordinates.lng) {
                return;
            }
            let icon = {
                url: location.pin || JSConst.absRefPrefix + 'app/themes/template/res/svg/src/map-marker.svg',
                scaledSize: new google.maps.Size(50, 50)
            };
            let position = new google.maps.LatLng(location.geo_coordinates.lat, location.geo_coordinates.lng);

            // create marker for each location
            let marker = new google.maps.Marker({
                position,
                map,
                icon,
                title: gmap.dataset.title
            });
            this.markers.push(marker);
            bounds.extend(position);

            marker.addListener('click', (e) => {
                infoWindow.close();
                infoWindow.setContent($(`[data-partnerid=${location.id}]`).first().wrap('<div></div>').parent().html());
                infoWindow.open(map, marker);
            });
        });

        map.fitBounds(bounds);

        gmap.dataset.gmap = 'initialized';

    }

    static loadApi() {
        window.GoogleMapInit = GoogleMap.init;
        let api = document.createElement('script');
        let apiKey = (typeof JSConst.googleMapsApiKey === 'string') ? JSConst.googleMapsApiKey : '';
        api.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=GoogleMapInit`);
        api.setAttribute('async', true);
        api.setAttribute('defer', true);
        document.head.appendChild(api);
    }

    static init() {
        $('[data-gmap]').each((index, el) => {
            new GoogleMap(el);
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/GoogleMap.js